@if (isLoading) {
    <div class="flex w-full items-center justify-center align-middle">
        <busy-spin class="p-2"></busy-spin>
    </div>
} @else if (!success) {
    <generic-error></generic-error>
}
